import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router';

import { getDivisionIcon } from '@/components/deprecated/DivisionIcon';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  TableWrapper,
} from '@/components/deprecated/OldTable';
import { LeagueHistory } from '@/features/league/types';

import { fetchLeagueHistory } from '../api/getLeagueHistory';

interface TeamHistoryProps {
  teamId: string;
}
const TeamHistory: React.FC<TeamHistoryProps> = ({ teamId }) => {
  const navigate = useNavigate();
  const { data: history } = useQuery({
    queryKey: ['history', teamId],
    queryFn: () => fetchLeagueHistory(teamId),
  });
  const handleRowClick = (league: LeagueHistory) => {
    navigate(`/league/${league.season_nr}/${league.division_nr}`);
  };

  if (!history) return null;

  return (
    <div className="inline-grid w-full flex-col overflow-hidden lg:flex">
      <div className="overflow-x-auto">
        <div className="mb-3 text-lg font-semibold">League History</div>
        <TableWrapper className="rounded-lg">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>
                  <span className="uppercase tracking-wide text-muted-foreground">
                    Season
                  </span>
                </TableHead>
                <TableHead>
                  <span className="uppercase tracking-wide text-muted-foreground">
                    Division
                  </span>
                </TableHead>
                <TableHead>
                  <span className="uppercase tracking-wide text-muted-foreground">
                    Wins
                  </span>
                </TableHead>
                <TableHead>
                  <span className="uppercase tracking-wide text-muted-foreground">
                    Losses
                  </span>
                </TableHead>
                <TableHead>
                  <span className="uppercase tracking-wide text-muted-foreground">
                    Playoffs
                  </span>
                </TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {history.map((row, index) => (
                <TableRow
                  key={index}
                  title="Go to league"
                  onClick={() => handleRowClick(row)}
                  className="cursor-pointer transition-colors"
                >
                  <TableCell className="font-medium tabular-nums ">
                    Season {row.season}
                  </TableCell>
                  <TableCell className="flex items-center gap-2 font-medium ">
                    {getDivisionIcon(row.division_nr, 'text-primary')}
                    {row.division_name}
                  </TableCell>
                  <TableCell className="font-medium ">
                    {row.history_win}
                  </TableCell>
                  <TableCell className="font-medium ">
                    {row.history_lose}
                  </TableCell>
                  <TableCell className="font-medium tabular-nums  ">
                    {row.playoffs_win}-{row.playoffs_lose}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableWrapper>
      </div>
    </div>
  );
};

export { TeamHistory };
